(() => {
  const norm = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function findLabel(root, names) {
    const els = root.querySelectorAll('button, a, [role="tab"], li, div, span');
    for (const el of els) {
      const t = norm(el.textContent);
      if (names.includes(t)) return el;
    }
    return null;
  }

  function ancestors(el, max = 8) {
    const out = [];
    let n = el;
    while (n && max-- > 0 && n !== document.body) {
      out.push(n);
      n = n.parentElement;
    }
    return out;
  }

  function clickableFor(label, candidate) {
    let el = label;
    for (let i = 0; i < 5 && el && candidate.contains(el); i++, el = el.parentElement) {
      if (el.matches && el.matches('button, a, [role="tab"], li')) return el;
    }
    return label.parentElement || label;
  }

  function forceTransparent(el) {
    if (!(el instanceof HTMLElement)) return;
    el.style.setProperty('background', 'transparent', 'important');
    el.style.setProperty('background-color', 'transparent', 'important');
    el.style.setProperty('background-image', 'none', 'important');
    el.style.setProperty('box-shadow', 'none', 'important');
  }

  function styleTab(el, active) {
    if (!(el instanceof HTMLElement)) return;
    el.classList.add('gogo-premium-tab');
    el.classList.toggle('gogo-premium-tab-active', !!active);
    el.style.setProperty('background', 'linear-gradient(180deg, #151c24 0%, #10161d 100%)', 'important');
    el.style.setProperty('background-color', '#121922', 'important');
    el.style.setProperty('background-image', 'linear-gradient(180deg, #151c24 0%, #10161d 100%)', 'important');
    el.style.setProperty('border', active ? '1px solid rgba(243,198,91,.30)' : '1px solid rgba(255,255,255,.075)', 'important');
    el.style.setProperty('color', active ? '#f3c65b' : '#aeb8c4', 'important');
    el.style.setProperty('-webkit-text-fill-color', active ? '#f3c65b' : '#aeb8c4', 'important');
    el.style.setProperty('box-shadow', 'inset 0 1px 0 rgba(255,255,255,.025), 0 5px 18px rgba(0,0,0,.16)', 'important');
    el.querySelectorAll('*').forEach((child) => {
      if (!(child instanceof HTMLElement)) return;
      child.style.setProperty('background', 'transparent', 'important');
      child.style.setProperty('background-color', 'transparent', 'important');
      child.style.setProperty('color', 'inherit', 'important');
      child.style.setProperty('-webkit-text-fill-color', 'inherit', 'important');
    });
  }

  function markTabs() {
    const main = document.getElementById('MainContent');
    if (!main) return;

    const desc = findLabel(main, ['beschrijving', 'description']);
    const ship = findLabel(main, ['shipping']);
    if (!desc || !ship) return;

    const da = ancestors(desc);
    const sa = new Set(ancestors(ship));
    let candidate = da.find((node) => sa.has(node));
    if (!candidate) return;

    for (const node of da) {
      if (!sa.has(node)) continue;
      const r = node.getBoundingClientRect();
      const text = norm(node.textContent);
      if (r.height > 0 && r.height <= 160 && r.width > 120 && text.includes('shipping') && (text.includes('beschrijving') || text.includes('description'))) {
        candidate = node;
        break;
      }
    }

    candidate.classList.add('gogo-force-transparent-tabs');
    forceTransparent(candidate);

    /* Maak alleen structurele wrappers transparant; de echte tabs worden donker. */
    [...candidate.children].forEach((child) => {
      if (!(child instanceof HTMLElement)) return;
      const t = norm(child.textContent);
      if (t.includes('shipping') && (t.includes('beschrijving') || t.includes('description'))) forceTransparent(child);
    });

    const descTab = clickableFor(desc, candidate);
    const shipTab = clickableFor(ship, candidate);

    const descActive = descTab.getAttribute('aria-selected') === 'true' || descTab.classList.contains('active') || descTab.classList.contains('is-active');
    const shipActive = shipTab.getAttribute('aria-selected') === 'true' || shipTab.classList.contains('active') || shipTab.classList.contains('is-active');

    /* Als de app geen state exposeert, is Beschrijving standaard actief. */
    styleTab(descTab, descActive || (!descActive && !shipActive));
    styleTab(shipTab, shipActive);
  }

  const run = () => requestAnimationFrame(markTabs);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();

  let timer;
  const observer = new MutationObserver(() => {
    clearTimeout(timer);
    timer = setTimeout(run, 70);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class','aria-selected','style'] });
  setTimeout(run, 350);
  setTimeout(run, 900);
  setTimeout(run, 1800);
})();
